import { useMutation, useQuery } from "@tanstack/react-query";
import {
  changePassword,
  getAllSecurityQuestions,
  getSecurityQuestionByUserId,

} from "../../services/authApi";
import { saveProfileToSession } from "./profile.utils";
import { SECURITY_QUESTIONS_QUERY_KEY, USER_SECURITY_QUESTION_QUERY_KEY } from "./profile.constants";


export const useSecurityQuestionsQuery = () =>
  useQuery({
    queryKey: SECURITY_QUESTIONS_QUERY_KEY,
    queryFn: getAllSecurityQuestions,
    staleTime: 5 * 60_000,
    gcTime: 10 * 60_000,
    placeholderData: [],
    retry: false,
  });

/** Looks up the user's saved security question id when it isn't already known (e.g. not cached in sessionStorage). */
export const useUserSecurityQuestionQuery = (userId, enabled) =>
  useQuery({
    queryKey: USER_SECURITY_QUESTION_QUERY_KEY(userId),
    queryFn: () => getSecurityQuestionByUserId(userId),
    enabled: enabled && Boolean(userId),
    staleTime: 5 * 60_000,
    retry: false,
    select: (data) => String(data.quesId),
  });

export const useSaveProfileMutation = () =>
  useMutation({
    mutationFn: (values) => saveProfileToSession(values),
  });

export const useChangePasswordMutation = () =>
  useMutation({
    mutationFn: (payload) => changePassword(payload),
  });
